import { UserFlags } from '@ordermentum/ui-types';
import { Location } from 'history';
import React from 'react';
import {
  AuthProvidersWrapper,
  GoogleButton,
  XeroButton,
} from './ProviderLogin.styles';
import { onGoogleButtonClick } from './SignUpFlow/utilities';

const GoogleLogin: React.FunctionComponent = () => (
  <div id="googleid-signin">
    <GoogleButton type="button" onClick={onGoogleButtonClick} />
  </div>
);

type Props = {
  flags: UserFlags;
  location?: Location;
};

export const ProviderLogin = (props: Props) => {
  const { location, flags } = props;

  // FIXME(JD): really should do a cookie drop and use a react context
  // rather than pushing location this deep
  const xeroQuery = !!location?.query?.xero;
  const showXero = flags?.['xero-login'] || xeroQuery;

  return (
    <AuthProvidersWrapper>
      {flags['google-login'] && <GoogleLogin />}
      {showXero && <XeroButton />}
    </AuthProvidersWrapper>
  );
};
